import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
} from '@angular/core';
import { DropdownOptionInterface, TogglerModel } from '@models/models';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DocumentModel, MultiuploadDocuments } from '@models/multiupload.model';
import { PBOptions } from '@models/progress-bar.model';
import { ProgressBarComponent } from '@shared/progress-bar/progress-bar.component';

@Component({
    selector: 'app-multiupload-files',
    templateUrl: './multiupload-files.component.html',
    styleUrls: ['./multiupload-files.component.scss'],
})
export class MultiuploadFilesComponent implements OnInit {
    files: File[] = [];

    @Input() toggler: TogglerModel;
    @Input() categories: DropdownOptionInterface[]; //if has categories means that documents can be categorized.
    @Input() privacity: boolean = false;
    @Input() edit: boolean = false;
    @Output() callback = new EventEmitter<any>();
    public docsForm: FormGroup;
    public privacityArray: boolean[] = [];
    public categorySelected: DropdownOptionInterface;
    public categoryCluster: MultiuploadDocuments[] = [];
    @ViewChild(ProgressBarComponent, { static: false })
    pbComponent: ProgressBarComponent;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        if (this.categories) {
            this.docsForm = this.formBuilder.group({
                category_docs: [''],
            });
            this.categorySelected = this.categories[0];
            this.categoryCluster.push(
                new MultiuploadDocuments(this.categorySelected.value, [])
            );
        }
    }

    onSelect(event: any, index: number): void {
        this.files.push(...event.addedFiles);

        if (this.categories) {
            this.categoryCluster[index].documents.push(
                ...event.addedFiles.map((f: File) => {
                    return new DocumentModel(f, false);
                })
            );
        }
        const formData = new FormData();

        for (var i = 0; i < this.files.length; i++) {
            formData.append('file[]', this.files[i]);
        }
    }

    onRemove(index: number, fileIndex: number): void {
        this.categoryCluster[index].documents.splice(fileIndex, 1);
    }

    onRemoveSingle(index: number) {
        this.files.splice(index, 1);
    }

    changePrivacity(event: any, index: number, fileIndex: number): void {
        this.categoryCluster[index].documents[fileIndex].internal = event;
    }

    getCategory(event: DropdownOptionInterface, index: number): void {
        this.categoryCluster[index].categoryName = event.value;
    }

    addNewCategoryCluster() {
        this.categoryCluster.push(
            new MultiuploadDocuments(this.categorySelected.value, [])
        );
    }

    deleteCategoryCluster(index: number) {
        this.categoryCluster.splice(index, 1);
    }

    getModalResult(event: any): void {
        if (event) {
            if (this.privacity) {
                this.callback.emit(this.categoryCluster);
                this.resetCategoryCluster();
            } else {
                this.callback.emit(this.files);
                this.files = [];
            }
        } else {
            this.resetCategoryCluster();
            this.files = [];
            this.toggler.close();
            this.pbComponent.end();
        }
    }

    resetCategoryCluster(): void {
        this.categoryCluster = [];
        this.categoryCluster.push(
            new MultiuploadDocuments(this.categorySelected.value, [])
        );
    }
}
